<template>
  <register-interest-data-provider
    v-slot="{ props, listeners }"
    :job-id="jobId"
  >
    <div
      class="Block Card has-border clearfix"
    >
      <div class="RegisterInterest-form">
        <h2>Register your interest</h2>
        <p>This job isn’t open yet! BUT, before it opens, you can register your interest. We’ll notify you when it’s time to apply. </p>
        <template v-if="!props.user.loggedIn">
          <div>
            <p> Log in to register your interest in this job. If you don’t have a RateMyApprenticeship account already, sign up here. It’s FREE!</p>
            <li class="SearchTypes-type">
              <a
                :class="[{ 'is-active': props.authType === 'login' }, 'SearchTypes-link']"
                href="#"
                @click.prevent="listeners.setAuthenticationComponent('login')"
              >
                Login
              </a>
            </li>
            <li class="SearchTypes-type">
              <a
                :class="[{ 'is-active': props.authType === 'register' }, 'SearchTypes-link']"
                href="#"
                @click.prevent="listeners.setAuthenticationComponent('register')"
              >
                Sign up
              </a>
            </li>
            <div>
              <social-authentication
                :import-comment="props.importComment"
              />
              <keep-alive>
                <component
                  :is="props.authenticationComponent"
                  :import-comment="props.importComment"
                  no-redirect
                />
              </keep-alive>
            </div>
          </div>
        </template>
        <template v-else>
          <register-interest-complete-profile-form
            :user="props.user"
            :questions-to-complete="props.questionsToComplete"
            :loading="props.loading"
            :validate-all="props.validateAll"
            :server-validation-errors="props.serverValidationErrors"
            :is-item-shortlisted="props.isItemShortlisted"
            :entities="props.entities"
            @register-interest-form:submit="listeners.handleSubmit"
            @register-interest-form:unregister-interest="listeners.unregisterInterest"
            @register-interest-form:validation-error="listeners.showValidationErrors"
          />
        </template>
      </div>
    </div>
  </register-interest-data-provider>
</template>
<script>
import { mapState } from 'vuex';
import SocialAuthentication from '@/components/authentication/common/social-account-auth-buttons.vue';
import RegisterInterestDataProvider from './register-interest-data-provider.vue';
import RegisterInterestCompleteProfileForm from './partials/register-interest-complete-profile-form.vue';

export default {
  name: 'RegisterInterest',
  components: {
    RegisterInterestDataProvider,
    RegisterInterestCompleteProfileForm,
    SocialAuthentication,
  },
  props: {
    jobId: {
      type: Number,
      default: null,
    },
  },
  computed: {
    ...mapState('user', {
      loggedIn: (state) => state.loggedIn,
    }),
  },
};
</script>

<style scoped type="text/css" lang="scss">
  @import "../../../scss/abstracts/abstracts";
  li {
    list-style: none;
  }
  .RegisterInterest-form {
    padding: spacing();
  }

    .SearchTypes-type {
      margin-bottom: .5rem;
      display: inline-flex;
      margin-right: 1em;
    }

    .SearchTypes-link {
      &:before {
        margin-top: 2px;
        width: 20px;
        height: 20px;
        border-radius: 20px;
        line-height: 20px;
        background: #e2e0dc;
        border: 1px solid #e2e0dc;
        float: left;
        content: '';
        margin-right: 10px;
        box-sizing: border-box;
      }
      &.is-active {
        &:before {
          border: 6px solid color($primary);
          background: #fff;
        }
      }
    }

  .MobileView {
    &.SearchTypes {
      display: flex;
      align-items: center;
      width: 100%;
      flex-direction: row;
      margin: 0 0 .5rem 0;
      @include respond-to(sm, max-width) {
        justify-content: space-between;
      }
    }

    .SearchTypes-type {
      padding: 0;
      margin-right: 1rem;
      color: color('white');
      &:last-child {
        margin: 0;
      }
      a {
        font-size: 16px;
        border-bottom: 2px solid transparent;
        padding: .5rem;
        display: block;
        color: color('white');
        &.is-active {
          border-color: #fff;
        }
      }
    }
  }

</style>
